<template>
    <div id="pay_bill" >
      <!-- Iframe para Dojo -->
      <teleport to="body">
        <div v-if="dojoUrl" style="background-color: rgba(139, 139, 139, 0.5); position: fixed; top: 0; left: 0; height: 100vh; width: 100vw; z-index: 10605 !important;" @click.self="dojoUrl = null" id="modal" class="d-flex align-items-center justify-content-center">
          <div style="height: 85vh; width: 95vw; max-width: 900px;" class="bg-white rounded-4 position-relative shadow-lg d-flex flex-column" id="modal-inner">
            <div class="d-flex justify-content-end p-2 position-absolute top-0 end-0 z-3">
              <button type="button" class="btn-close bg-white border shadow-sm p-2 rounded-circle" @click="CloseDojo()" aria-label="Close"></button>
            </div>
            <iframe id="iframe" :src="dojoUrl" class="w-100 flex-grow-1 border-0 rounded-4" allow="payment"></iframe>
          </div>
        </div>
      </teleport>

      <!-- Checkout Redsys dentro de EWU: el formulario POST se envía al iframe -->
      <teleport to="body">
        <div v-if="redsysAction" class="redsys-modal" @click.self="CloseRedsys">
          <div class="redsys-modal__content">
            <div class="d-flex justify-content-between align-items-center p-3 border-bottom">
              <strong>Pago seguro</strong>
              <button type="button" class="btn-close" @click="CloseRedsys" aria-label="Cerrar"></button>
            </div>
            <div v-if="redsysCompleting" class="redsys-modal__success" role="status" aria-live="polite">
              <div>
                <i class="fa-solid fa-circle-check me-2"></i>
                <strong>Pago realizado</strong>
                <span class="ms-2">Esta ventana se cerrará automáticamente.</span>
              </div>
              <div class="redsys-modal__countdown">{{ paymentCountdown }}</div>
            </div>
            <div v-else-if="redsysRollbackPending" class="redsys-modal__warning" role="status" aria-live="polite">
              <i class="fa-solid fa-triangle-exclamation me-2"></i>
              El pago fue autorizado, pero el pedido no pudo crearse. Estamos devolviendo el importe automáticamente.
            </div>
            <form ref="redsysForm" :action="redsysAction" method="POST" target="redsysFrame" class="d-none">
              <input v-for="(value, name) in redsysFormData" :key="name" type="hidden" :name="name" :value="value">
            </form>
            <iframe name="redsysFrame" title="Pago seguro Redsys" class="redsys-modal__frame" allow="payment"></iframe>
          </div>
        </div>
      </teleport>

      <div @click="onBackdropClick" class="h-100 w-100 position-fixed z-1">
      </div>
      <div v-if="paymentMethod==null && !is_delivery && (!is_take_away || is_counter) && !pay_at_order" class="bg-white expanded rounded-4 p-4 z-2 shadow-lg" style="max-width: 500px;">
        <!-- Header -->
        <div class="row m-0 mb-4">
          <div class="col-12 p-0">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <h2 class="m-0 fw-bold">Pagar Cuenta</h2>
              <button @click="Close()" class="btn btn-close"></button>
            </div>
            <div class="p-2 bg-light rounded-3 d-flex justify-content-around row m-0">
               <button 
                  class="btn flex-fill rounded-3 fw-semibold transition-all btn-dark text-white shadow-sm mb-3 py-3" 
                  @click="PedirCuenta()">
                  Pedir la cuenta
               </button>
               <button 
                  class="btn flex-fill rounded-3 fw-semibold transition-all btn-dark text-white shadow-sm py-3" 
                  @click="paymentMethod = 'movil'">
                  Pagar ahora
               </button>
            </div>
          </div>
        </div>
      </div>
      <!-- Efectivo con «pagar antes de pedir»: la comanda sale ya y se lleva la cuenta a la mesa. -->
      <div v-else-if="cashStep" class="bg-white expanded rounded-4 p-4 z-2 shadow-lg" style="max-width: 500px;" role="dialog" aria-modal="true" aria-labelledby="cash-step-title">
        <template v-if="cashStep === 'confirm'">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h2 id="cash-step-title" class="m-0 fw-bold fs-4">Pagar en efectivo</h2>
            <button type="button" class="btn btn-close" aria-label="Cerrar" :disabled="cashBusy" @click="cashStep = null"></button>
          </div>
          <p class="mb-3">Enviamos tu pedido a cocina ahora y te llevaremos la cuenta para que pagues en efectivo.</p>
          <p class="cash-step__total">Total <strong>{{ basePaymentAmount.toFixed(2) }}€</strong></p>
          <p v-if="paymentError" class="text-danger small" role="alert">{{ paymentError }}</p>
          <div class="d-grid gap-2">
            <button type="button" class="btn btn-dark btn-lg rounded-4 py-3" :disabled="cashBusy" @click="ConfirmCashOrder">
              {{ cashBusy ? 'Enviando el pedido…' : 'Confirmar pedido' }}
            </button>
            <button type="button" class="btn btn-outline-secondary rounded-4 py-2" :disabled="cashBusy" @click="cashStep = null">Volver</button>
          </div>
        </template>
        <div v-else class="text-center" role="status" aria-live="polite">
          <i class="fa-solid fa-circle-check text-success cash-step__icon mb-3" aria-hidden="true"></i>
          <h2 id="cash-step-title" class="fw-bold fs-4 mb-2">Pedido enviado</h2>
          <p class="mb-1">Paga <strong>{{ cashOrderAmount.toFixed(2) }}€</strong> en efectivo cuando te llevemos la cuenta.</p>
          <p class="text-muted small mb-3">No hace falta que vayas a la caja.</p>
          <button type="button" class="btn btn-dark rounded-4 px-4" @click="FinishCashOrder">Ver mis pedidos</button>
        </div>
      </div>
      <div v-else-if="payedConfirmed==null" class="bg-white expanded rounded-4 p-4 z-2 shadow-lg" style="max-width: 500px;">
        <div v-if="(!is_delivery && (!is_take_away || is_counter)) && !pay_at_order">
          <!-- Header -->
          <div class="row m-0 mb-4">
            <div class="col-12 p-0">
              <div class="d-flex justify-content-between align-items-center mb-3">
                <h2 class="m-0 fw-bold">Pagar Cuenta</h2>
                <button @click="Close()" class="btn btn-close"></button>
              </div>
              <div class="p-2 bg-light rounded-3 d-flex justify-content-around">
                <button 
                  class="btn flex-fill me-2 rounded-3 fw-bold transition-all" 
                  :class="selectedTab === 'split' ? 'btn-dark text-white shadow-sm' : 'text-muted'"
                  @click="selectedTab = 'split'">
                  Dividir
                </button>
                <button 
                  class="btn flex-fill rounded-3 fw-bold transition-all" 
                  :class="selectedTab === 'custom' ? 'btn-dark text-white shadow-sm' : 'text-muted'"
                  @click="selectedTab = 'custom'">
                  Manual
                </button>
              </div>
            </div>
          </div>

          <!-- Content -->
          <div class="mb-4">
            <!-- Split Bill Section -->
            <div v-if="selectedTab === 'split'" class="text-center animate-fade">
              <p class="text-muted mb-2">¿Cuántos sois?</p>
              <div class="d-flex justify-content-center align-items-center mb-0">
                  <button class="btn btn-outline-secondary rounded-circle p-2 px-3 fw-bold" @click="changePeople(-1)" :disabled="numPeople <= 1">-</button>
                  <span class="mx-4 fs-3 fw-bold" style="min-width: 30px;">{{ numPeople }}</span>
                  <button class="btn btn-outline-secondary rounded-circle p-2 px-3 fw-bold" @click="changePeople(1)">+</button>
              </div>
              <p class="mt-2 small text-muted">Total pendiente: {{ remainingAmount.toFixed(2) }}€</p>
            </div>

            <!-- Custom Amount Section -->
            <div v-else class="text-center animate-fade">
              <p class="text-muted mb-2">Introduce la cantidad</p>
              <div class="input-group mb-3 w-75 mx-auto">
                  <span class="input-group-text bg-transparent border-end-0 fs-4">€</span>
                  <input 
                    type="number" 
                    class="form-control border-start-0 fs-4 text-center" 
                    v-model.number="customAmount" 
                    placeholder="0.00"
                    step="0.01"
                    min="0.01"
                    :max="remainingAmount"
                  >
              </div>
              <p class="small text-muted">Total pendiente: {{ remainingAmount.toFixed(2) }}€</p>
            </div>
          </div>

          <hr class="text-muted opacity-25">
        </div>

        <!-- Tips Section -->
        <div v-if="tips_enabled" class="mb-4">
           <p class="fw-bold mb-2 small text-uppercase text-muted ls-1">Propina</p>
           <div class="d-flex justify-content-between gap-2 overflow-x-auto pb-2">
              <button 
                v-for="tip in [0, 5, 10, 15]" 
                :key="tip"
                class="btn btn-sm flex-grow-1 rounded-3 border"
                :class="selectedTip === tip ? 'btn-primary text-white border-primary' : 'btn-outline-light text-dark border-secondary'"
                @click="setTip(tip)"
              >
                <span v-if="tip === 0">No</span>
                <span v-else>{{ tip }}%</span>
              </button>
              <button 
                class="btn btn-sm flex-grow-1 rounded-3 border" 
                :class="selectedTip === 'custom' ? 'btn-primary text-white border-primary' : 'btn-outline-light text-dark border-secondary'"
                @click="selectedTip = 'custom'"
              >
                 Otro
              </button>
           </div>
           
           <div v-if="selectedTip === 'custom'" class="mt-2 input-group input-group-sm">
              <span class="input-group-text">€</span>
              <input type="number" class="form-control" v-model.number="customTipAmount" placeholder="Ej: 2.50">
           </div>
        </div>

        <!-- Summary and Action -->
        <CoordinatedRedsysAccount v-if="coordinatedQrFeature" :token="token" :backend="qrBackend"
          :amount="basePaymentAmount" :tip="tipValue" :provider="payment_method.toLowerCase()" @ready="qrCoordinated = $event.enabled"
          @balance="qrOutstanding = $event" @resolved="onCoordinatedResolved" />
         <div class="d-grid gap-2">
            <button
              class="btn btn-dark btn-lg rounded-4 shadow-sm py-3 d-flex justify-content-between align-items-center px-4"
              @click="PagarCuenta"
              v-if="hasGateway && (!coordinatedQrFeature || !qrCoordinated)"
              :disabled="finalAmount <= 0 || redirectingToRedsys || startingPayment"
            >
              <span class="fw-normal opacity-75">{{ redirectingToRedsys ? 'Abriendo el pago seguro…' : ((showBizum || showCash) ? 'Pagar con tarjeta' : 'Pagar') }}</span>
              <span class="fw-bold fs-5">{{ finalAmount.toFixed(2) }}€</span>
            </button>
            <button
              v-if="showBizum"
              class="btn btn-lg rounded-4 shadow-sm py-3 d-flex justify-content-between align-items-center px-4 bizum-pay-btn"
              @click="PagarCuentaRedsys(token, 'bizum')"
              :disabled="finalAmount <= 0 || redirectingToBizum || startingPayment"
            >
              <span class="fw-semibold">{{ redirectingToBizum ? 'Abriendo Bizum…' : 'Pagar con Bizum' }}</span>
              <span class="fw-bold fs-5">{{ finalAmount.toFixed(2) }}€</span>
            </button>
            <button
              v-if="showCash"
              type="button"
              class="btn btn-lg rounded-4 shadow-sm py-3 d-flex justify-content-between align-items-center px-4 cash-pay-btn"
              @click="OpenCashStep"
              :disabled="basePaymentAmount <= 0 || startingPayment"
            >
              <span class="fw-semibold"><i class="fa-solid fa-money-bill-wave me-2" aria-hidden="true"></i>Pagar en efectivo</span>
              <span class="fw-bold fs-5">{{ basePaymentAmount.toFixed(2) }}€</span>
            </button>
            <p v-if="paymentError" class="text-danger small text-center mb-0" role="alert">{{ paymentError }}</p>
         </div>

      </div>
      <div v-else-if="payedConfirmed" class="bg-white expanded rounded-4 p-4 z-2 shadow-lg" style="max-width: 500px;">
        <p class="text-center px-5 fw-bold fs-5"><i class="fa-solid fa-circle-check text-success fs-5 me-2"></i> Pago realizado correctamente</p>
        <p v-if="finalPayedAmount" class="text-center px-5 fw-semibold fs-5">Cantidad pagada: <span class="fw-bold fs-3">{{ finalPayedAmount.toFixed(2) }}€</span></p>
        <p v-if="paymentCountdown !== null" class="text-center text-muted mb-0">
          Procesando el pedido y cerrando en
          <strong class="text-dark fs-4">{{ paymentCountdown }}</strong>
          segundos
        </p>
      </div>
      <div v-else class="bg-white expanded rounded-4 p-4 z-2 shadow-lg" style="max-width: 500px;">
        <p class="text-center px-5 fw-semibold fs-5"><i class="fa-solid fa-circle-xmark text-danger fs-5 me-2"></i> {{ paymentFailureMessage }}</p>
      </div>
    </div>
  </template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';
import { rememberRedsysRedirect, submitRedsysFormFullPage } from '@/services/payments/redsysRedirect';
import CoordinatedRedsysAccount from './CoordinatedRedsysAccount.vue';
import { setPwaUpdateBlocker } from '@/utils/pwa';

const API = () => `${process.env.VUE_APP_API_URL}/v1/api/app`;
const DOJO_FAILED_STATUSES = ['Cancelled', 'Canceled', 'Refunded', 'RefundFailed', 'Failed'];

function newUuid() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
    const value = Math.floor(Math.random() * 16);
    return (char === 'x' ? value : ((value & 0x3) | 0x8)).toString(16);
  });
}

export default {
  name: 'PagarCuenta',
  components: { CoordinatedRedsysAccount },
  emits: ['closePay', 'PedirCuenta', 'PedidoPagado', 'PointsEarned', 'payError', 'cartChanged'],
  props: {
    totalAmount: {
        type: Number,
        default: 0
    },
    payedAmount: {
        type: Number,
        default: 0
    },
    is_delivery: {
        type: Boolean,
        default: false
    },
    is_take_away: {
        type: Boolean,
        default: false
    },
    is_counter: {
        type: Boolean,
        default: false
    },
    pay_at_order: {
      type: Boolean,
      default: false
    },
    payment_context: {
      type: String,
      default: 'account'
    },
    reward_id: {
        type: [String, Number],
        default: null
    },
    plate_reward_id: {
        type: [String, Number],
        default: null
    },
    payment_method:{
      type: String,
      default: null
    },
    // Bizum por Redsys (mismo comercio y clave que la tarjeta).
    bizum_enabled: {
      type: Boolean,
      default: false
    },
    // El restaurante puede quitar la propina (Ajustes → Pagos).
    tips_enabled: {
      type: Boolean,
      default: true
    },
    // Carrito con «pagar antes de pedir»: [{id, amount}] tal como lo ve el
    // cliente. Al elegir el método esas líneas se apartan en un lote.
    cart_lines: {
      type: Array,
      default: () => []
    },
    // El restaurante deja pedir y pagar en efectivo.
    cash_enabled: {
      type: Boolean,
      default: false
    },
    // Lote ya apartado que se vuelve a intentar pagar (Mis pedidos).
    batch: {
      type: Object,
      default: null
    }
  },
  data: function() {
      return {
        selectedTab: 'split', // 'split' | 'custom'
        qrCoordinated: true,
        qrOutstanding: null,
        numPeople: 1,
        customAmount: null,
        selectedTip: 0, // 0, 5, 10, 15, 'custom'
        customTipAmount: 0,
        payedConfirmed: null,
        finalPayedAmount: null,
        paymentMethod: null,
        dojoUrl: null,
        redsysTransactionId: null,
        redsysInterval: null,
        redsysAction: null,
        redsysFormData: {},
        paymentCountdown: null,
        paymentCountdownInterval: null,
        redsysCompleting: false,
        redsysRollbackPending: false,
        redirectingToBizum: false,
        redirectingToRedsys: false,
        paymentFailureMessage: 'Ha habido un error al realizar el pago',
        // Lote creado al elegir el método (o el que se reintenta).
        batchId: null,
        ownBatch: false,
        startingPayment: false,
        paymentError: '',
        dojoInterval: null,
        dojoPaymentIntentId: null,
        cashStep: null, // null | 'confirm' | 'done'
        cashBusy: false,
        cashRequestId: null,
        cashOrderAmount: 0,
      }
    },
  computed:{
    qrBackend() { return `${process.env.VUE_APP_API_URL}/v1/api`; },
    coordinatedQrFeature() { return process.env.VUE_APP_QR_ACCOUNT_CHECKOUT_UI_ENABLED === 'true'
      && ['Redsys', 'Monei', 'Dojo'].includes(this.payment_method) && this.payment_context !== 'cart'; },
    ...mapState(['token']),
    showBizum() {
      return this.payment_method === 'Redsys' && this.bizum_enabled
        && (!this.coordinatedQrFeature || !this.qrCoordinated);
    },
    // Pago del carrito con «pagar antes de pedir»: se aparta un lote.
    usesBatches() {
      return this.payment_context === 'cart' && this.pay_at_order;
    },
    hasGateway() {
      return ['Monei', 'Dojo', 'Redsys'].includes(this.payment_method);
    },
    showCash() {
      return this.usesBatches && this.cash_enabled && !this.batch && !this.reward_id;
    },
    remainingAmount() {
        if (this.batch) return Math.max(0, Number(this.batch.amount) || 0);
        if (this.coordinatedQrFeature && this.qrCoordinated && Number.isSafeInteger(this.qrOutstanding)) return this.qrOutstanding / 100;
        return Math.max(0, this.totalAmount - this.payedAmount);
    },
    basePaymentAmount() {
        if (this.selectedTab === 'split') {
            return this.remainingAmount / this.numPeople;
        } else {
            return this.customAmount || 0;
        }
    },
    tipValue() {
        if (!this.tips_enabled) return 0;
        if (this.selectedTip === 'custom') {
            return this.customTipAmount || 0;
        }
        return (this.basePaymentAmount * this.selectedTip) / 100;
    },
    finalAmount() {
        return this.basePaymentAmount + this.tipValue;
    }
  },
  mounted() {
    // Con el cliente pagando no se recarga sola la app por una versión nueva.
    setPwaUpdateBlocker('customer-payment', true);
  },
  beforeUnmount() {
    setPwaUpdateBlocker('customer-payment', false);
  },
  watch: {
    remainingAmount: {
      immediate: true,
      handler(val) {
        if (this.selectedTab === 'custom' && !this.customAmount) {
            this.customAmount = val;
        }
      }
    },
    selectedTab(val) {
        if (val === 'custom' && !this.customAmount) {
            this.customAmount = this.remainingAmount;
        }
    }
  },
  methods: {
    onCoordinatedResolved(result) {
      if (result.state === 'settled' && result.status === 'authorized') this.$emit('PedidoPagado');
      this.Close();
    },
    PedirCuenta(){
      this.$emit('closePay');
      this.$emit('PedirCuenta');
    },
    changePeople(delta) {
        this.numPeople = Math.max(1, this.numPeople + delta);
    },
    setTip(percentage) {
        this.selectedTip = percentage;
        this.customTipAmount = 0;
    },
    onBackdropClick() {
      if (this.cashStep === 'done') {
        this.FinishCashOrder();
        return;
      }
      if (this.payedConfirmed || this.cashBusy || this.startingPayment) return;
      this.Close();
    },
    authHeaders() {
      return { Authorization: `Bearer ${this.token}` };
    },
    // Aparta las líneas que ve el cliente para pagarlas. Devuelve el id del
    // lote o null si no es un pago del carrito con «pagar antes de pedir».
    async ensureBatch(method) {
      if (!this.usesBatches) return null;
      if (this.batch?.id) return this.batch.id;
      if (this.batchId) return this.batchId;
      const response = await axios.post(`${API()}/cart-payment-batches`, {
        batch_id: newUuid(),
        lines: this.cart_lines && this.cart_lines.length ? this.cart_lines : null,
        method,
        reward_id: this.reward_id || null,
      }, { headers: this.authHeaders() });
      this.batchId = response.data.id;
      this.ownBatch = true;
      return this.batchId;
    },
    // El pago no llegó a abrirse: los productos vuelven al carrito.
    async releaseOwnBatch() {
      if (!this.ownBatch || !this.batchId) return;
      const batchId = this.batchId;
      this.batchId = null;
      this.ownBatch = false;
      try {
        await axios.post(`${API()}/cart-payment-batches/${batchId}/cancel`, null, { headers: this.authHeaders() });
      } catch (error) {
        console.warn('No se pudo devolver el lote al carrito:', error);
      }
      this.$emit('cartChanged');
    },
    handleStartError(error) {
      const status = error?.response?.status;
      const data = error?.response?.data || {};
      if (['cart_changed', 'cart_empty', 'batch_closed', 'batch_not_found'].includes(data.code)) {
        this.$emit('cartChanged', data.error || 'El carrito ha cambiado. Revisa los productos antes de pagar.');
        this.Close();
        return;
      }
      // Sin stock, faltan datos o la cocina está cerrada: lo muestra el carrito.
      const stock = data.error === 'stock_unavailable' || data.code === 'INGREDIENT_STOCK_UNAVAILABLE';
      if (stock || [401, 403, 418].includes(status)) {
        this.$emit('payError', error);
        this.Close();
        return;
      }
      if (status && data.error) {
        this.paymentError = data.error;
        return;
      }
      this.$emit('payError', error);
    },
    OpenCashStep() {
      this.paymentError = '';
      this.cashRequestId = newUuid();
      this.cashStep = 'confirm';
    },
    async ConfirmCashOrder() {
      if (this.cashBusy) return;
      this.cashBusy = true;
      this.paymentError = '';
      try {
        const response = await axios.post(`${API()}/cart-cash-orders`, {
          request_id: this.cashRequestId,
          lines: this.cart_lines,
        }, { headers: this.authHeaders() });
        this.cashOrderAmount = Number(response.data?.amount) || this.basePaymentAmount;
        if (typeof response.data?.points === 'number' && response.data.points > 0) {
          this.$emit('PointsEarned', response.data.points);
        }
        this.cashStep = 'done';
      } catch (error) {
        const data = error?.response?.data || {};
        const stock = data.error === 'stock_unavailable' || data.code === 'INGREDIENT_STOCK_UNAVAILABLE';
        if (data.code === 'cart_changed' || data.code === 'cart_empty') {
          this.$emit('cartChanged', data.error);
          this.Close();
        } else if (stock || (error?.response && [403, 418, 401].includes(error.response.status))) {
          this.$emit('payError', error);
          this.Close();
        } else {
          this.paymentError = data.error || 'No se ha podido enviar el pedido. Inténtalo de nuevo.';
        }
      } finally {
        this.cashBusy = false;
      }
    },
    FinishCashOrder() {
      this.cashStep = null;
      this.$emit('PedidoPagado');
      this.Close();
    },
    Close(){
      if (this.dojoInterval) clearInterval(this.dojoInterval);
      this.dojoInterval = null;
      this.cashStep = null;
      this.paymentError = '';
      this.paymentMethod = null;
      this.dojoUrl = null;
      this.redsysAction = null;
      this.redsysFormData = {};
      if (this.redsysInterval) clearInterval(this.redsysInterval);
      if (this.paymentCountdownInterval) clearInterval(this.paymentCountdownInterval);
      this.redsysInterval = null;
      this.paymentCountdownInterval = null;
      this.paymentCountdown = null;
      this.redsysCompleting = false;
      this.redsysRollbackPending = false;
      this.redsysTransactionId = null;
      this.$emit('closePay');
    },
    CloseRedsys(){
      if (this.redsysInterval) clearInterval(this.redsysInterval);
      this.redsysInterval = null;
      this.redsysAction = null;
      this.redsysFormData = {};
      this.redsysTransactionId = null;
    },
    CompleteRedsysPayment(responseData, sentAmount) {
      if (this.redsysCompleting) return;
      this.redsysCompleting = true;
      if (this.redsysInterval) clearInterval(this.redsysInterval);
      this.redsysInterval = null;

      // Mantener visible el recibo de Redsys durante la cuenta atrás para que
      // el cliente pueda revisarlo o hacer una captura.
      this.finalPayedAmount = sentAmount;
      this.payedConfirmed = true;
      this.paymentCountdown = 10;

      if (typeof responseData.points === 'number') {
        this.$emit('PointsEarned', responseData.points);
      }

      this.paymentCountdownInterval = setInterval(() => {
        this.paymentCountdown -= 1;
        if (this.paymentCountdown <= 0) {
          clearInterval(this.paymentCountdownInterval);
          this.paymentCountdownInterval = null;
          this.$emit('PedidoPagado');
          this.Close();
          this.payedConfirmed = null;
        }
      }, 1000);
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    async CloseDojo(){
      this.dojoUrl = null;
      if (this.dojoInterval) clearInterval(this.dojoInterval);
      this.dojoInterval = null;
      document.getElementById("spinner").classList.add("d-none")
      // Puede que el pago acabe de completarse: se comprueba antes de
      // devolver los productos al carrito.
      if (this.dojoPaymentIntentId && await this.checkDojoStatus(this.dojoPaymentIntentId)) return;
      await this.releaseOwnBatch();
      this.payedConfirmed = false;
      await this.sleep(2000);
      this.Close();
      this.payedConfirmed = null;
    },
    // true si el pago ya se ha resuelto (cobrado o rechazado).
    async checkDojoStatus(paymentIntentId) {
      let res;
      try {
        res = await axios.get(`${API()}/checkPaymentStatusDojo`, {
          params: { payment_intent_id: paymentIntentId },
          headers: this.authHeaders(),
        });
      } catch (error) {
        console.warn('No se pudo consultar el pago Dojo:', error);
        return false;
      }
      const status = res.data?.status;
      if (status === 'Captured') {
        if (this.dojoInterval) clearInterval(this.dojoInterval);
        this.dojoInterval = null;
        this.dojoUrl = null;
        this.finalPayedAmount = this.finalAmount;
        this.payedConfirmed = true;
        if (res.data && typeof res.data.points === 'number' && res.data.points) {
          this.$emit('PointsEarned', res.data.points);
        }
        await this.sleep(3000);
        this.$emit('PedidoPagado');
        this.Close();
        this.payedConfirmed = null;
        return true;
      }
      if (DOJO_FAILED_STATUSES.includes(status)) {
        if (this.dojoInterval) clearInterval(this.dojoInterval);
        this.dojoInterval = null;
        this.dojoUrl = null;
        this.paymentFailureMessage = status === 'Refunded'
          ? 'No se pudo crear el pedido. Se ha devuelto el importe.'
          : 'El pago no se ha completado. No se ha cobrado nada.';
        this.payedConfirmed = false;
        // El servidor ya ha devuelto los productos al carrito.
        this.$emit('cartChanged');
        await this.sleep(3000);
        this.Close();
        this.payedConfirmed = null;
        return true;
      }
      return false;
    },
    async PagarCuenta(){
      const token = this.token; 
      
      if(this.payment_method == 'Monei'){
        this.PagarCuentaMonei(token);
      }else if(this.payment_method == 'Dojo'){
        this.PagarCuentaDojo(token);
      }else if(this.payment_method == 'Redsys'){
        this.PagarCuentaRedsys(token);
      }else{
        const error = new Error('No hay una pasarela de pago configurada para esta mesa');
        console.error(error);
        this.$emit('payError', error);
      }
    },
    async PagarCuentaRedsys(token, payMethod = 'card') {
      if (this.coordinatedQrFeature && this.qrCoordinated) return;
      if (this.startingPayment) return;
      this.paymentError = '';
      this.startingPayment = true;
      let batchId = null;
      try {
        batchId = await this.ensureBatch(payMethod === 'bizum' ? 'bizum' : 'card');
      } catch (error) {
        this.startingPayment = false;
        this.handleStartError(error);
        return;
      }
      try {
        const baseAmount = Number(this.basePaymentAmount);
        const tipAmount = Number(this.tipValue);
        if (!Number.isFinite(baseAmount) || baseAmount <= 0 || !Number.isFinite(tipAmount) || tipAmount < 0) {
          throw new Error(`Importe de carrito no válido: base=${baseAmount}, propina=${tipAmount}`);
        }
        const response = await axios.post(
          `${process.env.VUE_APP_API_URL}/v1/api/app/payments/redsys/session`,
          null,
          { params: {
              amount: baseAmount.toFixed(2),
              tip: tipAmount.toFixed(2),
              cart_payment: this.payment_context === 'cart',
              pay_method: payMethod,
              batch_id: batchId || undefined,
              reward_id: (this.payment_context === 'cart' && this.reward_id) || undefined,
              // Redsys se abre a pantalla completa y vuelve a este origen.
              return_origin: window.location.origin
            }, headers: { Authorization: `Bearer ${token}` } }
        );
        const formData = response.data;
        const sentAmount = Number(formData.amount);
        if (!Number.isFinite(sentAmount) || sentAmount <= 0) {
          throw new Error(`Redsys ha recibido un importe no válido: ${formData.amount}`);
        }
        // Tarjeta y Bizum van a Redsys a pantalla completa y al terminar vuelven a
        // /PagoRedsys/:id/:resultado, que consulta el estado del pago. Dentro de
        // un iframe Redsys rechaza Bizum (SIS0476) y la autenticación 3DS de
        // muchos bancos no termina: en Redsys queda «Sin finalizar 9999».
        if (payMethod === 'bizum') this.redirectingToBizum = true;
        else this.redirectingToRedsys = true;
        rememberRedsysRedirect({
          transactionId: formData.transaction_id,
          context: this.payment_context,
          amount: sentAmount,
          batchId: formData.batch_id || batchId,
        });
        submitRedsysFormFullPage(formData.action, {
          Ds_SignatureVersion: formData.Ds_SignatureVersion,
          Ds_MerchantParameters: formData.Ds_MerchantParameters,
          Ds_Signature: formData.Ds_Signature
        });
      } catch (error) {
        this.redirectingToBizum = false;
        this.redirectingToRedsys = false;
        this.startingPayment = false;
        console.error('Error iniciando Redsys:', error);
        await this.releaseOwnBatch();
        this.handleStartError(error);
      }
    },
    async PagarCuentaDojo(token) {
      if (this.coordinatedQrFeature && this.qrCoordinated) return;
      if (this.startingPayment) return;
      this.paymentError = '';
      this.startingPayment = true;
      let batchId = null;
      try {
        batchId = await this.ensureBatch('card');
      } catch (error) {
        this.startingPayment = false;
        this.handleStartError(error);
        return;
      }
      try {
        // amount = importe base (sin propina), tip = propina. En el carrito
        // el servidor cobra el importe del lote.
        const params = {
          amount: this.basePaymentAmount.toFixed(2),
          tip: this.tipValue.toFixed(2),
          cart_payment: this.payment_context === 'cart',
        };
        if (batchId) params.batch_id = batchId;
        if (this.payment_context === 'cart' && this.reward_id) params.reward_id = this.reward_id;
        const response = await axios.get(`${API()}/createPagoDojo`, { params, headers: { Authorization: `Bearer ${token}` } })

        const { url, payment_intent_id } = response.data
        this.dojoPaymentIntentId = payment_intent_id
        this.dojoUrl = url
        this.startingPayment = false;

        this.dojoInterval = setInterval(() => this.checkDojoStatus(payment_intent_id), 3000)
      } catch (error) {
        this.startingPayment = false;
        console.error(error)
        await this.releaseOwnBatch();
        this.handleStartError(error);
      }
    },
    async PagarCuentaMonei(token){
      if (this.coordinatedQrFeature && this.qrCoordinated) return;
      if (this.startingPayment) return;
      this.paymentError = '';
      // 1. Verify if the order can be paid (kitchen open, user data complete, etc.)
      const checkParams = [];
      if (this.reward_id) checkParams.push(`reward_id=${this.reward_id}`);
      if (this.plate_reward_id) checkParams.push(`plate_reward_id=${this.plate_reward_id}`);
      const checkUrlStr = checkParams.length > 0 ? `?${checkParams.join('&')}` : '';
      
      try {
        document.getElementById("spinner").classList.remove("d-none")
        await axios.get(`${process.env.VUE_APP_API_URL}/v1/api/app/checkCanPay${checkUrlStr}`, {
           headers: { 'Authorization': `Bearer ${token}` }
        });
      } catch (error) {
        document.getElementById("spinner").classList.add("d-none")
        this.$emit('payError', error);
        return; // Abort payment, keep PagarCuenta open
      }

      this.startingPayment = true;
      let batchId = null;
      try {
        batchId = await this.ensureBatch('card');
      } catch (error) {
        document.getElementById("spinner").classList.add("d-none")
        this.startingPayment = false;
        this.handleStartError(error);
        return;
      }

      // GET: obtener payment_id de MONEI. En el carrito el servidor cobra el importe del lote.
      const createParams = {
        amount: this.basePaymentAmount.toFixed(2),
        tip: this.tipValue.toFixed(2),
        cart_payment: this.payment_context === 'cart',
      };
      if (batchId) createParams.batch_id = batchId;
      if (this.payment_context === 'cart' && this.reward_id) createParams.reward_id = this.reward_id;

      try {
        document.getElementById("spinner").classList.remove("d-none")
        const response = await axios.get(`${API()}/createPago`, {
          params: createParams,
          headers: { 'Authorization': `Bearer ${token}` }
        });

        let pago = response.data.payment_id
        let pay_id = response.data.pay_id
        const chargedBase = Number(response.data.amount ?? this.basePaymentAmount)
        const chargedTip = Number(response.data.tip ?? this.tipValue)
        this.startingPayment = false;

        const monei = window.monei;

        if (!monei) {
          console.error('MONEI no cargado');
          document.getElementById("spinner").classList.add("d-none")
          await this.releaseOwnBatch();
          return;
        }

        monei
          .confirmPayment({paymentId: pago}) 
          .then(async (result) => {
            console.log('Payment confirmation result:', result);

            // POST: el servidor comprueba el pago con Monei antes de aplicarlo.
            let confirmUrl = `${process.env.VUE_APP_API_URL}/v1/api/app/createPago`
              + `?amount=${chargedBase.toFixed(2)}`
              + `&tip=${chargedTip.toFixed(2)}`
              + `&pay_id=${pay_id}`
              + `&payment_id=${pago}`
              + `&cart_payment=${this.payment_context === 'cart'}`;
            if (this.reward_id) confirmUrl += `&reward_id=${this.reward_id}`;
            if (this.plate_reward_id) confirmUrl += `&plate_reward_id=${this.plate_reward_id}`;
            
            const payload = {};
            if (this.reward_id) payload.reward_id = this.reward_id;
            if (this.plate_reward_id) payload.plate_reward_id = this.plate_reward_id;
      
            try {
              document.getElementById("spinner").classList.remove("d-none")
              const postResponse = await axios.post(confirmUrl, payload, {
                headers: { 'Authorization': `Bearer ${token}` }
              });
              
              const responseData = postResponse.data;
              if (responseData && responseData.points && typeof responseData.points === 'number') {
                this.$emit('PointsEarned', responseData.points);
              }
              if (postResponse.status === 202) {
                // Monei aún no lo da por cobrado: aparecerá en Mis pedidos al confirmarse.
                this.paymentFailureMessage = 'Aún no tenemos la confirmación del pago. No vuelvas a pagar: aparecerá en tus pedidos en cuanto se confirme.';
                document.getElementById("spinner").classList.add("d-none")
                this.payedConfirmed = false;
                await this.sleep(5000);
                this.$emit('PedidoPagado');
                this.Close();
                this.payedConfirmed = null;
                return;
              }
            }
            catch (error) {
              document.getElementById("spinner").classList.add("d-none")
              const data = error?.response?.data || {};
              this.paymentFailureMessage = data.code === 'order_failed'
                ? (data.error || 'No se pudo crear el pedido.')
                : 'El pago no se ha completado.';
              if (data.code === 'payment_failed' || data.code === 'order_failed') this.$emit('cartChanged');
              this.payedConfirmed = false;
              await this.sleep(5000);
              this.Close();
              this.payedConfirmed = null;
              return;
            }
            document.getElementById("spinner").classList.add("d-none")
            this.finalPayedAmount = this.finalAmount;
            this.payedConfirmed = true;
            await this.sleep(3000);
            this.$emit('PedidoPagado');
            this.Close();
            this.payedConfirmed = null;
            this.finalPayedAmount = null;
          })
          .catch(async (error) => {
            document.getElementById("spinner").classList.add("d-none")
            // Pago cerrado o rechazado: los productos vuelven al carrito (si
            // Monei llegara a cobrarlo, el servidor lo devuelve).
            await this.releaseOwnBatch();
            this.paymentFailureMessage = 'El pago no se ha completado.';
            this.payedConfirmed = false;
            await this.sleep(5000);
            this.Close();
            this.payedConfirmed = null;
            console.error('Error confirming payment:', error);
          });
      } catch (error) {
        document.getElementById("spinner").classList.add("d-none")
        this.startingPayment = false;
        console.error('Error al obtener la cuenta:', error);
        await this.releaseOwnBatch();
        this.handleStartError(error);
      }
    }
  }
}

</script>
  
  <style scoped>
  #pay_bill {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6); /* Darker backdrop */
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10600 !important;
    backdrop-filter: blur(3px); /* Glassmorphism effect */
  }

  .expanded{
    width: 90%;
    transition: transform 0.3s ease-in-out;
  }

  .redsys-modal {
    position: fixed;
    inset: 0;
    z-index: 10610;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem;
    background: rgba(0, 0, 0, 0.65);
    backdrop-filter: blur(3px);
  }

  .redsys-modal__content {
    width: min(96vw, 620px);
    height: min(90vh, 820px);
    overflow: hidden;
    display: flex;
    flex-direction: column;
    background: #fff;
    border-radius: 1rem;
    box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.3);
  }

  .redsys-modal__success {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    padding: 0.85rem 1rem;
    color: #14532d;
    background: #dcfce7;
    border-bottom: 1px solid #86efac;
    animation: fadeIn 0.25s ease-in-out;
  }

  .redsys-modal__countdown {
    flex: 0 0 auto;
    display: grid;
    place-items: center;
    width: 2.5rem;
    height: 2.5rem;
    color: #fff;
    font-size: 1.15rem;
    font-weight: 800;
    background: #15803d;
    border-radius: 999px;
  }

  .redsys-modal__warning {
    padding: 0.85rem 1rem;
    color: #78350f;
    font-weight: 600;
    background: #fef3c7;
    border-bottom: 1px solid #fcd34d;
    animation: fadeIn 0.25s ease-in-out;
  }

  .redsys-modal__frame {
    display: block;
    flex: 1 1 auto;
    min-height: 0;
    width: 100%;
    height: auto;
    border: 0;
  }

  /* Custom Styles for better aesthetics */
  .transition-all {
    transition: all 0.2s ease;
  }

  .ls-1 {
    letter-spacing: 1px;
  }

  .animate-fade {
    animation: fadeIn 0.3s ease-in-out;
  }

  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(5px); }
    to { opacity: 1; transform: translateY(0); }
  }
  .bizum-pay-btn {
    background-color: #05c3c8;
    border-color: #05c3c8;
    color: #fff;
  }

  .bizum-pay-btn:hover,
  .bizum-pay-btn:focus {
    background-color: #04a9ad;
    border-color: #04a9ad;
    color: #fff;
  }

  .cash-pay-btn {
    background-color: #fff;
    border: 2px solid #1a1a1a;
    color: #1a1a1a;
  }

  .cash-pay-btn:hover,
  .cash-pay-btn:focus {
    background-color: #f5f5f5;
    color: #1a1a1a;
  }

  .cash-step__total {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    padding: 0.75rem 1rem;
    margin-bottom: 1rem;
    font-size: 1.1rem;
    background: #f6f7fb;
    border-radius: 0.75rem;
  }

  .cash-step__total strong {
    font-size: 1.5rem;
  }

  .cash-step__icon {
    font-size: 3.5rem;
  }

  /* Input number hide arrows */
  input[type=number]::-webkit-inner-spin-button, 
  input[type=number]::-webkit-outer-spin-button { 
    -webkit-appearance: none; 
    margin: 0; 
  }
</style>
